import { render, staticRenderFns } from "./bauauftrag.vue?vue&type=template&id=74e8c1d6&"
import script from "./bauauftrag.vue?vue&type=script&lang=js&"
export * from "./bauauftrag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports